<template>
  <article class="popup popup-padding">
    <header class="popup-top">
      <h2 class="title">{{$t('roles.setInGroup')}}</h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('labels.prompt')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form @submit.prevent="setIngroup"
          class="add-user-form">

      <!--<upload-avatar @upload="addAvatar($event)"></upload-avatar>-->

      <div class="select-cont ">
        <p class="label">{{$t('popups.addUser.setSubgroup')}}</p>
        <v-select
          :searchable="false"
          :clearable="false"
          label="name"
          :placeholder="$t('labels.choose')"
          v-model="group"
          :options="groups"></v-select>
      </div>

      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled=" disableBtn || loading"
                :class="{'loading': loading}"

                class="btn btn-blue">{{$t('btns.accept')}}</button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";
  import {required, email} from 'vuelidate/lib/validators'
  import errors from '../../Forms/errors'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import uploadAvatar from '../../uploadAvatar'
  import {toFormData} from "../../../mixins/utils/toFormData";

  export default {
    name: 'addRoleInGroup',
    mixins: [popups, tokenAndRoute, toFormData],
    components: {
      closeBtn,
      questionBtn,
      errors,
      uploadAvatar
    },
    data() {
      return {
        group: this.$t('labels.choose'),
        loading: false,

      }
    },
    computed: {
      ...mapState({
        ownedRoles: state => state.roles.ownedRoles,
        groups: state => state.roles.rolesGroups,
        mailError: state => state.roles.doubleMailError,
        userData: state => state.auth.user,
        checkedRoles: state => state.popups.addRoleInGroup.roles
      }),
      disableBtn() {
        return (!this.group);
      },
    },
    methods: {
      ...mapMutations({
      }),
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',
        setRoleInGroup: 'roles/updateRole',
      }),
      async setIngroup() {
        this.loading = true;
        let rolesList = this.checkedRoles;
        for (let i = 0; i < rolesList.length; i++) {
          let item = rolesList[i];
          let name = item.data.role.name;
          let id = item.data.role.id || item.id;
          let description = item.data.role.description || item.description;

          let data = {
            group_id: this.group.id,
          //  access_token: this.token,
            id,
            name,
            description
          };
          let formData = this.toFormData(data)

          await this.setRoleInGroup({token: this.token, data: formData, reloadData: true})
            .then(async () => {
            })
        };
        await this.getOwnedRoles({token: this.token, id: ''});
        this.loading = false;
        this.closeAll();
      }
    },
  }
</script>

<style lang="scss" scoped>
  .input-cont {
    margin-bottom: 20px;
  }

  .check-cont {
    margin-top: 20px;
  }

</style>
